<template>
    <div class="tag" :title="buildTitle" :class="buildColor"/>
</template>

<script>

  export default {
    computed: {
      buildColor() {
        if (this.label && this.label.color)
          return `tag-${this.label.color}`
        else if (this.label)
          return 'tag-blue'
        else
          return ''
      },
      buildTitle() {
        if (this.label && this.label.name)
          return this.label.name
        else
          return ''
      }
    },
    name: 'BkpsLabel',
    props: ['label']
  }
</script>

<style>

</style>
